import { Phone } from "lucide-react";
import { NAP, BOOKING_URL } from "../lib/config";

export default function MobileStickyBar() {
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-[#E5DFD3] flex divide-x divide-[#E5DFD3] shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
    >
      <a
        href={`tel:${NAP.phoneTel}`}
        className="flex-1 flex items-center justify-center gap-2 py-4 text-[#1A1A1A] font-bold"
        data-testid="sticky-bar-call"
        style={{ fontFamily: "'Nunito', sans-serif" }}
      >
        <Phone className="h-4 w-4 text-[#B94A15]" /> Call
      </a>
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center py-4 bg-[#E85D26] text-white font-bold"
        data-testid="sticky-bar-book"
        style={{ fontFamily: "'Nunito', sans-serif" }}
      >
        Book Now
      </a>
    </div>
  );
}
